import {Component} from '@angular/core';

@Component({
    selector: 'ccl-form-item-label',
    template: `
        <ng-content></ng-content>
    `,
    styles: [
            `
            :host {
                display: block;
            }
        `
    ]
})
export class FormItemLabelComponent {
}
